import DataQueries                       from '../graphql/Queries';
import generatorDialogModel, {
  GeneratorDialogModel
}                                        from '../schedule/GeneratorDialogModel';
import { DefaultSchema, IEditPanelView } from './SettingsModel';
import { MasterDataSettingsModel }       from './MasterDataSettingsModel';
import GeneratorEditPanelHeaderView      from './GeneratorEditPanelHeaderView';
import GeneratorEditPanelView            from './GeneratorEditPanelView';
import GeneratorEditorView               from './GeneratorEditorView';
import mainPageModel                     from '../main-navigation/MainPageModel';
import { GeneratorSort }                 from '../DataTypes';

export default class GeneratorsSettingsModel extends MasterDataSettingsModel {
  constructor() {
    super('Shift Pattern', 'generators', generatorDialogModel);
    this.EditPanelView       = GeneratorEditPanelView as IEditPanelView;
    this.EditPanelHeaderView = GeneratorEditPanelHeaderView;
    this.EditPanelFormView   = GeneratorEditorView;
  }
  protected async _load(filter: {search?: string}, sort?: GeneratorSort) {
    const results = (await DataQueries.getGenerators(DefaultSchema + 'archived', filter, sort, this.paging.itemsPerPage, this.paging.currentPage));
    this.setItems(results.data);
    return results;
  }

  get _canAddItem(): boolean {
    return mainPageModel.canAddGenerators;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditGenerators;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canDeleteGenerators;
  }

  getDefaultEditPanelHeaderOptionsItems() {
    let options = super.getDefaultEditPanelHeaderOptionsItems();
    options     = options.map(o => {
      const optionDisabled = o.disabled;
      const option         = {...o};
      if (option.name !== 'Udfs') {
        option.disabled = () => !!((this.editor as GeneratorDialogModel).locked || (typeof optionDisabled === 'function' ? optionDisabled() : optionDisabled));
      }
      return option;
    });
    return options;
  }
}
